import * as React from "react";
import ExternalLink from "components/ExternalLink/ExternalLink";
import InternalLink from "components/InternalLink/InternalLink";
import OnboardingPage from "../../../../components/GettingStarted/OnboardingPage";

const Onboarding = () => {
  const panels = [
    {
      imageSrc: require("./onboarding-steps.svg"),
      description: <div>
        The Octopus built-in steps are powerful and flexible to handle the most common deployment scenarios, such as deploying an IIS Web Site or a Windows Service application.
      </div>
    },
    {
      imageSrc: require("./onboarding-communitysteps.svg"),
      description: <div>
        Octopus Community Library integration makes it easy to find step templates that work with the frameworks and technologies you use without the need for custom scripting.
      </div>
    }
  ];

  return (
    <OnboardingPage
      title="Add steps to configure your deployment process"
      intro="A deployment process specifies the steps to deploy an application, which allows you to deploy new versions consistently every time."
      learnMore={<p>Learn more about <ExternalLink href="OnboardingAddStepsLearnMore">adding steps</ExternalLink>.</p>}
      panels={panels} />
  );
};

export default Onboarding;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/projects/components/DeploymentProcess/Onboarding.tsx